import React, { useState, useEffect } from 'react';
import { getUser } from '../utils/authUtil';
import API from '../services/api';
import './QuestionBank.css'; // Reuse existing styles
import './SuperAdminQuestionBank.css';

const TopicsManager = () => {
  const user = getUser();
  const isSuperAdmin = user?.role === 'super_admin';

  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  
  const [form, setForm] = useState({ name: '', category: 'quantitative' });
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');

  useEffect(() => {
    fetchTopics();
  }, []);

  const fetchTopics = async () => {
    setLoading(true);
    try {
      const res = await API.get('/questions/topics?includeEmpty=true');
      setTopics(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');

    if (!form.name.trim()) return setFormError('Topic name is required');
    if (!form.category) return setFormError('Category is required');

    try {
      await API.post('/questions/topics', form);
      setFormSuccess('Topic added successfully!');
      fetchTopics();
      setForm({ name: '', category: 'quantitative' });
      setTimeout(() => {
        setShowForm(false);
        setFormSuccess('');
      }, 1500);
    } catch (err) {
      setFormError(err.response?.data?.message || 'Failed to add topic');
    }
  };

  return (
    <div className="sa-qb-container">
      <div className="sa-qb-header">
        <div>
          <h1>Topics Database</h1>
          <p>Manage aptitude and technical topics for the placement system</p>
        </div>
        <div className="sa-qb-actions">
          {isSuperAdmin && (
            <button className="btn-add-global" onClick={() => setShowForm(true)}>
              + Add New Topic
            </button>
          )}
        </div>
      </div>

      <div className="sa-qb-content">
        {loading ? (
          <div className="sa-loader">Loading topics...</div>
        ) : (
          <div className="sa-table-wrapper">
            <table className="sa-questions-table">
              <thead>
                <tr>
                  <th>Topic Name</th>
                  <th>Category</th>
                  <th>System Slug</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {topics.map(t => (
                  <tr key={t.id}>
                    <td><strong>{t.name}</strong></td>
                    <td style={{textTransform: 'capitalize'}}>{t.category}</td>
                    <td><span className="topic-tag" style={{background: '#f1f5f9', color: '#475569'}}>{t.slug}</span></td>
                    <td>
                      <span className={`diff-badge ${t.is_active ? 'easy' : 'hard'}`}>
                        {t.is_active ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))}
                {topics.length === 0 && (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>No topics found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showForm && isSuperAdmin && (
        <div className="sa-modal-overlay">
          <div className="sa-modal" style={{ maxWidth: '500px' }}>
            <div className="sa-modal-header">
              <h2>Add New Topic</h2>
              <button className="close-btn" onClick={() => setShowForm(false)}>×</button>
            </div>
            
            {formError && <div className="alert error">{formError}</div>}
            {formSuccess && <div className="alert success">{formSuccess}</div>}

            <form onSubmit={handleSubmit}>
              <div className="sa-form-grid">
                <div className="sa-form-group full">
                  <label>Topic Name *</label>
                  <input 
                    type="text" 
                    required
                    placeholder="e.g. Probability, Arrays, Verbal Logic"
                    value={form.name} 
                    onChange={e => setForm({...form, name: e.target.value})} 
                  />
                </div>
                
                <div className="sa-form-group full">
                  <label>Category *</label>
                  <select 
                    required 
                    value={form.category}
                    onChange={e => setForm({...form, category: e.target.value})}
                  >
                    <option value="quantitative">Quantitative Aptitude</option>
                    <option value="logical">Logical Reasoning</option>
                    <option value="verbal">Verbal Reasoning</option>
                    <option value="communication">Communication</option>
                  </select>
                </div>
              </div>

              <div className="sa-modal-footer">
                <button type="button" className="sa-btn-cancel" onClick={() => setShowForm(false)}>Cancel</button>
                <button type="submit" className="sa-btn-save">Save Topic</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopicsManager;
